export default {
      id: "d_lettre-usage",
      viewBox: "0 0 53 51",
      url: "../dist/images/" + "sprite.svg#d_lettre-usage",
      toString: function () {
        return this.url;
      }
    }